module.exports = __webpack_public_path__ + "img/30_19.8797c26e.png";